import '.ek{flex-shrink:0;}.ssr-plugin'
import '.h6{min-width:260px;}.ssr-plugin'
import '.ai{max-width:480px;}.ssr-plugin'
import '.a7{position:relative;}.ssr-plugin'
import '.am{height:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import '.aa{user-select:none;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.ab{gap:24px;}.ssr-plugin'
import '.al{flex:1;}.ssr-plugin'
import '.ce{overflow:auto;}.ssr-plugin'
import '.eo{gap:2px;}.ssr-plugin'
import '.h7{padding:8px 8px 4px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.h8{padding-top:4px;}.ssr-plugin'
import '.h9{padding-bottom:4px;}.ssr-plugin'
import '.cv{padding-left:8px;}.ssr-plugin'
import '.gn{padding-right:8px;}.ssr-plugin'
import '.h0{min-height:32px;}.ssr-plugin'
import '.bk{gap:8px;}.ssr-plugin'
import '.k{cursor:pointer;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.a1{gap:4px;}.ssr-plugin'
import '.ha{min-height:24px;}.ssr-plugin'
import { ReactNode, createContext, useContext } from 'react'
import { Icon, IconProps } from '../Icon/index.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { Counter } from '../Counter/index.js'

type SidebarContextType = {
  value?: string
  onChange: (value: string) => void
}
const SidebarContext = createContext<SidebarContextType>({ onChange: () => {} })

type SidebarProps = {
  value?: string
  onChange: (value: string) => void
  children: ReactNode
  side?: 'left' | 'right' | false
}

function Sidebar({ children, value, onChange, side = 'left' }: SidebarProps) {
  return (
    <SidebarContext.Provider value={{ value, onChange }}>
      <div className="ek h6 ai a7 am a ac aa"
      >
        <div className="f am a ac ab"
        >
          {children}
        </div>
      </div>
    </SidebarContext.Provider>
  )
}

type SidebarHeaderProps = {
  children: ReactNode
}

function SidebarHeader({ children }: SidebarHeaderProps) {
  return <div className="a">{children}</div>
}

type SidebarFooterProps = {
  children: ReactNode
}

function SidebarFooter({ children }: SidebarFooterProps) {
  return <div className="a">{children}</div>
}

type SidebarItemsProps = {
  children: ReactNode
}

function SidebarItems({ children }: SidebarItemsProps) {
  return (
    <div className="al ab a f ac ce"
    >
      {children}
    </div>
  )
}

type SidebarGroupProps = {
  children: ReactNode
  title: string
}

function SidebarGroup({ title, children }: SidebarGroupProps) {
  return (
    <div className="a ac eo">
      <div className="h7">
        <Text selectableText={false} variant="subtext-medium" color="neutral60">
          {title}
        </Text>
      </div>
      {children}
    </div>
  )
}

type SidebarItemProps = {
  children: ReactNode
  value: string
  icon?: IconProps['variant']
  description?: string
  counter?: number
}

function SidebarItem({
  children,
  value,
  icon,
  description,
  counter,
}: SidebarItemProps) {
  const { value: contextValue, onChange } = useContext(SidebarContext)
  const active = value === contextValue

  return (
    <styled.div className="a d h8 h9 cv gn h0 bk k"
      data-active={active ? active : undefined}
      style={{
        borderRadius: radius[12],
        '&:hover:not([data-active])': {
          background: colors.neutral10Adjusted,
        },
        '&[data-active]': {
          background: colors.neutral10Adjusted,
        },
        '&[data-active]:hover': {
          background: colors.neutral10Adjusted,
        },
      }}
      onClick={() => {
        onChange(value)
      }}
    >
      {icon && <Icon variant={icon} />}
      <div className="a ac c a1 ha"
      >
        <Text selectableText={false} color="neutral80" variant="display-medium">
          {children}
        </Text>
        {description && (
          <Text
            selectableText={false}
            color="neutral60"
            variant="subtext-regular"
          >
            {description}
          </Text>
        )}
      </div>
      {counter > 0 && (
        <Counter style={{ marginLeft: 'auto' }}>{counter}</Counter>
      )}
    </styled.div>
  )
}

Sidebar.Items = SidebarItems
Sidebar.Group = SidebarGroup
Sidebar.Item = SidebarItem
Sidebar.Header = SidebarHeader
Sidebar.Footer = SidebarFooter

export { Sidebar }
export type { SidebarProps }
